import React from 'react'

import ReactDatetime, { DatetimepickerProps } from 'react-datetime'

import styles from './reactDatetimeOverride.styles'
import { getDateFormatBasedOnLocale } from './dateTimePickersUtils'

import DatePickerInput from './DatePickerInput'
import { Box } from '@chakra-ui/react'

interface DatePickerProps extends DatetimepickerProps {
  className?: string
  disablePastDays?: boolean
  fullWidth?: boolean
  dataTest?: string
}

const DatePicker = ({
  className,
  disablePastDays = false,
  fullWidth = false,
  dataTest = 'DatePicker',
  ...props
}: DatePickerProps) => {
  const dateFormat = getDateFormatBasedOnLocale()

  return (
    <Box
      className={styles}
      w={fullWidth ? '100%' : 'auto'}
      data-test={dataTest}
    >
      <ReactDatetime
        className={className}
        dateFormat={dateFormat}
        timeFormat={false}
        renderInput={(inputProps, openCalendar) => {
          return (
            <DatePickerInput
              {...inputProps}
              datePickerDateValue={props.value}
              openCalendar={openCalendar}
              disablePastDays={disablePastDays}
            />
          )
        }}
        closeOnSelect
        {...props}
      />
    </Box>
  )
}

export default DatePicker
